import { i18n } from '@fs/zion-locale'
import useCountry from './useCountry'
import { pacificCountryCodes } from '../../team-spaces/asia-pacific/countryCodes'

/**
 * Hook that returns APAC region information for the current user.
 * @returns {{isAsiaPacific: boolean, siteName: string}}
 * - isAsiaPacific: Whether the user is in the APAC region based on country and language
 * - siteName: Site name for analytics and targeting features
 */
export default function useAsiaPacific() {
  const countryCode = useCountry()
  const language = i18n.language
  const siteName = getSiteName(countryCode, language)

  return {
    isAsiaPacific: siteName !== 'default',
    siteName,
  }
}

/**
 * Determines the APAC site name based on country code and language.
 * Internal function - use useAsiaPacific() hook in components.
 * @param {string} countryCode - The user's country code
 * @param {string} language - The user's language code
 * @returns {string} The site name or 'default' if not APAC
 */
function getSiteName(countryCode, language) {
  // Country-specific with language check
  if (countryCode === 'AU' && language === 'en') return 'australia'
  if (countryCode === 'IN' && language === 'en') return 'india'
  if (countryCode === 'NZ' && language === 'en') return 'newzealand'
  if (countryCode === 'PH' && language === 'en') return 'philippines'
  if (pacificCountryCodes.includes(countryCode) && language === 'en') return 'pacific'

  // Language-only countries
  if (language === 'ja') return 'japan'
  if (language === 'ko') return 'korea'
  if (language === 'th') return 'thailand'
  if (language === 'km') return 'cambodia'
  if (language === 'id') return 'indonesia'
  if (language === 'ms') return 'malaysia'
  if (language === 'mn') return 'mongolia'
  if (language === 'vi') return 'vietnam'

  return 'default'
}
